import { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import BottomTabBar from "./BottomTabBar";

export default function Layout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <div className="flex min-w-0 overflow-hidden">
        <Sidebar
          collapsed={sidebarCollapsed}
          onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        />
        {/* The mobile bottom padding clears the BottomTabBar via --tabbar-height. Every lg:
            side is explicit because bare pt-3/pt-4 would out-cascade lg:p-6. */}
        <main
          className={`flex-1 pt-3 pb-[calc(var(--tabbar-height)+1.5rem)] sm:pt-4 lg:px-6 lg:pt-6 lg:pb-6 transition-all duration-300 min-w-0 overflow-hidden ${
            sidebarCollapsed ? "lg:pl-4" : "lg:pl-8"
          }`}
        >
          <Outlet />
        </main>
      </div>
      <BottomTabBar />
    </div>
  );
}
